import { Inject,Injectable } from '@angular/core';
import {
ActivatedRouteSnapshot,
NavigationExtras,
Router,
RouterStateSnapshot,
} from '@angular/router';
import { LogServiceToken,RoleServiceToken } from '../services';
import { ILogService,IRoleService } from '../services/i';

@Injectable()
export class RoleGuard {
  constructor(
    private router: Router,
    @Inject(RoleServiceToken) private roleService: IRoleService,
    @Inject(LogServiceToken) private log: ILogService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true;

    this.log.debug('can activate?', route.routeConfig.path);
    const can = this.roleService.canActivate(
      route.routeConfig.path,
      route.queryParams
    );
    this.log.debug('can: ', can);
    if (can) {return can;}

    this.router.navigate(['/help'], <NavigationExtras>{
      fragment: 'authorization',
    });
    return false;
  }
}
